export { default } from './useGeneratedAttachmentUrl';
